import {EnvConfig} from './envConfig.interface';
import {productionConfig} from './production';
import {stagingConfig} from './staging';

export const ENV: EnvConfig[] = [...stagingConfig, ...productionConfig];
